import { Button, Tooltip, useToast } from '@chakra-ui/react';
import { trpcAdmin } from '@duke-hq/app-admin-web/lib/trpcAdmin';
import { Trans } from '@lingui/react/macro';
import { t } from '@lingui/core/macro';
import { unitAssessmentState } from '../UnitAssessment/UnitAssessmentState';
import { useSnapshot } from 'valtio';
import { useParams } from 'react-router-dom';

export function AssessmentPublishButton() {
  const { unitId } = useParams();
  const unitAssessmentSnap = useSnapshot(unitAssessmentState);
  const unitAssessmentVersionId = unitAssessmentSnap.draftVersionId;
  const hasIncompleteSlides = unitAssessmentSnap.incompleteSlides.length > 0;
  const toast = useToast();
  const utils = trpcAdmin.useUtils();

  const publish = trpcAdmin.unitAssessment.publish.useMutation({
    onSuccess: () => {
      unitAssessmentState.setHasUnpublishedChanges(false);
      if (unitId != null) {
        void utils.unitAssessment.byUnitId.invalidate(unitId);
      }
      toast({
        title: t`Assessment published`,
        description: t`The assessment has been successfully published.`,
        status: 'success',
        duration: 5000,
        isClosable: true,
      });
    },
    onError: (error) => {
      toast({
        title: t`Error`,
        description: error.message || t`Failed to publish assessment.`,
        status: 'error',
        duration: 5000,
        isClosable: true,
      });
    },
  });

  if (unitAssessmentVersionId === null) {
    return null;
  }

  // The unpublished/published state is carried by the toolbar's status badge, so
  // this is just the action. Matches the other editors' primary/sm publish style.
  return (
    <Tooltip label={t`Fix incomplete slides before publishing.`} isDisabled={!hasIncompleteSlides}>
      <Button
        variant="primary"
        size="sm"
        isLoading={publish.isPending}
        isDisabled={hasIncompleteSlides}
        onClick={async () => {
          await publish.mutateAsync({ unitAssessmentVersionId });
        }}
      >
        <Trans>Publish</Trans>
      </Button>
    </Tooltip>
  );
}
